import { useAppSelector } from '../index';
import { Modals } from '../../constants/modals';

export const useModal = (key: Modals) => {
  return useAppSelector(state => state.modals[key]);
};
